module.exports = __webpack_public_path__ + "slick.ced611daf7709cc778da.eot";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/assets/slick/fonts/slick.eot
// module id = ../../../../../src/assets/slick/fonts/slick.eot
// module chunks = styles